const SkeletonNews = () => {
  return (
    <div className="my-2 animate-pulse space-y-8 rounded-lg bg-medium-gray md:flex md:items-center md:space-x-8 md:space-y-0 rtl:space-x-reverse">
      <div className="w-full">
        <div className="mb-2.5 h-2 max-w-[480px] rounded-full bg-blue-gray dark:bg-gray-700" />
        <div className="mb-2.5 h-2 max-w-[440px] rounded-full bg-blue-gray dark:bg-gray-700" />
        <div className="h-2 max-w-[360px] rounded-full bg-blue-gray dark:bg-gray-700" />
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default SkeletonNews;
